import axios from 'axios'

export default {
  data: () => ({ numberAccessLoading: false, numberAccessAllowed: false, numberAccessError: '' }),
  methods: {
    async checkNumberAccess() {
      this.numberAccessLoading = true
      this.numberAccessAllowed = false
      this.numberAccessError = ''
      try {
        const { data } = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/access-status`, {
          headers: { Authorization: 'Bearer ' + this.$store.state.auth.jwt }
        })
        this.numberAccessAllowed = data.can_purchase_numbers === undefined ? !data.pending : data.can_purchase_numbers
        if (!this.numberAccessAllowed) {
          this.numberAccessError = 'You can set up your workspace now. Phone number purchases become available after your introduction and agency approval.'
        }
      } catch (e) {
        this.numberAccessError = 'Unable to check phone number access. Close this dialog and try again.'
      } finally {
        this.numberAccessLoading = false
      }
      return this.numberAccessAllowed
    }
  }
}
